export default {
  layout: 'default',
  blocks: [
    {
      module: 'hcAboutIntro',
    },
    {
      module: 'hcAbout',
    },
    {
      module: 'image',
      src: require('./images/About-Us-Studio-Photo.jpg'),
      alt: 'Image of some people working at Particle',
    },
    {
      module: 'hiring',
      heading: {
        jobs: 'We&rsquo;re hiring.',
        noJobs: 'We&rsquo;re usually hiring.',
      },
      teaser: {
        jobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.',
        noJobs: 'Want to help us create meaningful design in the everyday world? Join our growing team.',
      },
      listings: [
        // {
        //   jobTitle: 'Interaction Designer',
        //   listingURL: 'https://www.linkedin.com/jobs/view/622160016/',
        //   description: 'Make usuable, useful things',
        // },
        // {
        //   jobTitle: 'Sr. Front-End Developer',
        //   listingURL: 'https://www.linkedin.com/jobs/view/622112067/',
        //   description: 'Come play with us. Build prototypes for clients like Virgin Hyperloop One and Samsung and have a great time doing it.',
        // },
      ],
      noJobsContent: 'We don&rsquo;t have any specific needs, but we&rsquo;re always open to meeting new people. Feel free to introduce yourself.',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/content/about/content.js